/** Per-user tab slug: feed grid has been painted at least once (shop/content tab switches). */
const feedReadyByKey = new Map<string, boolean>();

export function templateTabFeedCacheKey(
  userId: string,
  renderSlug: string,
): string {
  return `${String(userId || "").trim()}:${String(renderSlug || "").trim().toLowerCase()}`;
}

export function isTemplateTabFeedReady(
  userId: string,
  renderSlug: string,
): boolean {
  const key = templateTabFeedCacheKey(userId, renderSlug);
  return key !== ":" && feedReadyByKey.get(key) === true;
}

export function markTemplateTabFeedReady(
  userId: string,
  renderSlug: string,
): void {
  const key = templateTabFeedCacheKey(userId, renderSlug);
  if (key !== ":") feedReadyByKey.set(key, true);
}
